export const removeAllDuplicates = (arr: string[]) => Array.from(new Set(arr));
